<template>
  <div>
    <v-data-table
      :page="table.page"
      :headers="headers"
      :items="table.items"
      :items-per-page="table.itemsPerPage"
      :loading="loading.table"
      :server-items-length="table.totalCount"
      :footer-props="{
        'items-per-page-options': table.itemsPerPageOptions,
        itemsPerPageText: this.$t('defaults.table.items-per-page-text'),
        pageText: this.$t('defaults.table.page-text'),
      }"
      :no-data-text="$t('defaults.table.no-data-text')"
      :loading-text="$t('defaults.table.loading-text')"
      :options.sync="table.options"
      class="d-table"
      @update:options="optionsUpdated"
    >
      <template v-slot:[`item.isActive`]="{ item }">
        <v-chip outlined :color="item.isActive ? 'success' : 'error'">{{
          item.isActive
            ? $t("defaults.text.active")
            : $t("defaults.text.inactive")
        }}</v-chip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <div class="d-flex align-center justify-end">
          <v-tooltip top v-if="item.isClient">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                color="gray darken-2"
                icon
                :to="{ name: 'UserPermissions', params: { id: item.id } }"
              >
                <v-icon size="24"> mdi-tune-variant </v-icon>
              </v-btn>
            </template>
            <span>{{ $t("defaults.button.permissions") }}</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                color="gray darken-2"
                icon
                @click="$emit('edit', item)"
              >
                <v-icon size="24"> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>{{ $t("defaults.button.edit") }}</span>
          </v-tooltip>

          <v-menu bottom offset-y content-class="elevation-0 mt-1 rounded">
            <template v-slot:activator="{ on, attrs }">
              <div v-bind="attrs" v-on="on">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" color="gray darken-2" icon>
                      <v-icon> mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>
                  <span>{{ $t("defaults.text.other-actions") }}</span>
                </v-tooltip>
              </div>
            </template>

            <v-list outlined class="rounded" dense>
              <v-list-item @click="$emit('changeStatus', item)">
                <v-list-item-title>
                  <span class="body-2">{{
                    item.isActive
                      ? $t("defaults.button.deactivate")
                      : $t("defaults.button.activate")
                  }}</span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import tableMixins from "@/mixins/tableMixins";
import { getUsers } from "@/services/user";

export default {
  mixins: [tableMixins],
  data() {
    return {
      headers: [
        {
          text: this.$t("users.list.table.headers.status"),
          value: "isActive",
          sortable: false,
          width: "100px",
        },
        {
          text: this.$t("users.list.table.headers.organization"),
          value: "organizationName",
          sortable: false,
        },
        {
          text: this.$t("users.list.table.headers.user-type"),
          value: "userTypeName",
          sortable: false,
        },
        {
          text: this.$t("users.list.table.headers.username"),
          value: "username",
          sortable: false,
        },

        { text: "", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  props: {
    searchParams: Object,
  },
  methods: {
    handleFetchItems() {
      this.table.options.page = 1;
      this.table.page = 1;
      this.fetchItems();
    },
    fetchItems() {
      this.loading.table = true;
      getUsers({
        pageSize: this.table.itemsPerPage,
        pageNumber: this.table.page,
        ...this.searchParams,
      })
        .then((response) => {
          this.table.items = response.items;
          this.table.totalCount = response.totalCount;

          if (
            response.totalCount <=
            (this.table.options.page - 1) * this.table.itemsPerPage
          ) {
            this.table.options.page = 1;
          }
        })
        .catch(() => {
          this.table.items = [];
          this.table.totalCount = 0;
        })
        .finally(() => {
          this.loading.table = false;
        });
    },
  },
  mounted() {
    this.$eventBus.$on("fetchUsers", this.handleFetchItems);
  },
  beforeDestroy() {
    this.$eventBus.$off("fetchUsers", this.handleFetchItems);
  },
};
</script>
